
import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { whyUsReasons } from '../../../mocks/services';

/* Animation variants */
const fadeInUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' },
  },
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 },
  },
};

export default function WhyUs() {
  // Ref for the section that we want to observe
  const ref = useRef<HTMLDivElement>(null);

  // Safeguard: useInView expects a valid element, so we guard against null
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px',
  });

  return (
    <section className="py-20 px-6 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <motion.div
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
          variants={staggerContainer}
          className="text-center mb-16"
        >
          <motion.p
            variants={fadeInUp}
            className="text-sm text-red-600 font-medium mb-3"
          >
            Farkımız
          </motion.p>
          <motion.h2
            variants={fadeInUp}
            className="text-5xl font-bold text-gray-900 mb-4"
          >
            NEDEN BİZİ SEÇMELİSİNİZ?
          </motion.h2>
          <motion.p
            variants={fadeInUp}
            className="text-gray-600 max-w-2xl mx-auto"
          >
            Yangın güvenliği konusunda sektörün en güvenilir çözüm ortağı
            olarak, kalite ve müşteri memnuniyetini ön planda tutuyoruz.
          </motion.p>
        </motion.div>

        {/* Reasons grid */}
        <motion.div
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
          variants={staggerContainer}
          className="grid md:grid-cols-3 gap-8"
        >
          {whyUsReasons.map((reason, index) => (
            <motion.article
              key={reason.id ?? index}
              variants={fadeInUp}
              whileHover={{
                y: -8,
                boxShadow: '0 20px 40px -12px rgba(0,0,0,0.12)',
              }}
              className="bg-gray-50 rounded-2xl p-8 transition-all duration-300 cursor-pointer group"
            >
              <motion.div
                whileHover={{ rotate: 10, scale: 1.1 }}
                transition={{ type: 'spring', stiffness: 300 }}
                className="w-14 h-14 flex items-center justify-center bg-red-100 rounded-2xl mb-5 group-hover:bg-red-600 transition-colors duration-300"
              >
                <i
                  className={`${reason.icon} text-2xl text-red-600 group-hover:text-white transition-colors duration-300`}
                ></i>
              </motion.div>

              <h3 className="text-lg font-bold text-gray-900 mb-3">
                {reason.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
